import {SubRouter} from 'core/components';
const DashboardRoutes = ({modules}) => {
  return <SubRouter modules={modules} defaultRedirection='' />;
};
export default DashboardRoutes;
